import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { DesignerContextType } from '../../types/designer-context-type';
import { CompleteDesignerContext } from './completeContext';
import { SxMainContainer } from './main-container.component';
import { SxInternalStateDesignerService } from '../../services/internal-state-designer-service';

@Component({
  templateUrl: './sidebar.component.html',
  selector: 'sx-sidebar-designer'
})
export class SxSideBarDesignerComponent {
  @Input()
  selected: string;
  @Input()
  searchAtt: string;
  @Input()
  isNonTransactional: boolean;

  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // Application Context
  @Input()
  completeContext: CompleteDesignerContext;
  @Input()
  attFiltered: any[];
  @Input()
  veFiltered: any[];
  @Input()
  viewEngines: any[];
  // PrincipalDesignerReference
  @Input()
  mainContainer: SxMainContainer;

  @Output()
  filterAtt: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  removeDesignerMen: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  loadStateFromEditor: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  changePanel: EventEmitter<string> = new EventEmitter<string>();

  constructor( public internalState: SxInternalStateDesignerService) {}

  showDefaultPanel() {
    this.designerContext.designerLoaded = false;
    if ((this.selected == 'advancedPanel')) {
      this.cancelProductDesign();
      this.loadStateFromEditor.emit();
    }

    this.selected = 'defaultPanel';
    this.changePanel.emit(this.selected);
  }

  showAdvancedPanel() {
    this.removeDesignerMen.emit();
    this.selected = 'advancedPanel';
    this.changePanel.emit(this.selected);
  }

  // resets back to empty forms
  cancelProductDesign(): void {
    this.removeDesignerMen.emit();
    const designerToDestroy = [];
    this.mainContainer.childsDesigners.forEach(d =>
      designerToDestroy.push(this.designerContext.designers[d.id])
    );
    designerToDestroy.forEach(d => d.destroy());
  }
  setFilter(): void {
    this.internalState.setCurrentFilterAttr(this.searchAtt)
    this.filterAtt.emit();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/sidebar.component.ts